import TextInput from "./TextInput"

export default function EmailInput({
  control,
  name = "email",
  requiredErrorMessage = "Please enter an email address.",
  validEmailErrorMessage = "Please enter a valid email address.",
  ...textFieldProps
}) {
  const rules = {
    required: {
      message: requiredErrorMessage,
      value: true,
    },
    pattern: {
      message: validEmailErrorMessage,
      value: /\S+@\S+\.\S+/,
    },
  }

  return (
    <TextInput
      name={name}
      control={control}
      rules={rules}
      {...textFieldProps}
    />
  )
}
